import { GlButton, GlFormGroup, GlFormInput, GlModal, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import csrf from '~/lib/utils/csrf';
import eventHub from '../event_hub';
import { I18N_DELETE_TAG_MODAL } from '../constants';
export default {
    name: 'DeleteTagModal',
    csrf,
    components: {
        GlModal,
        GlButton,
        GlFormGroup,
        GlFormInput,
        GlSprintf
    },
    data () {
        return {
            isProtected: false,
            tagName: '',
            path: '',
            enteredTagName: '',
            modalId: 'delete-tag-modal'
        };
    },
    computed: {
        title () {
            return this.isProtected ? this.$options.i18n.modalTitleProtectedTag : this.$options.i18n.modalTitle;
        },
        message () {
            return this.isProtected ? this.$options.i18n.modalMessageProtectedTag : this.$options.i18n.modalMessage;
        },
        buttonText () {
            return this.isProtected ? this.$options.i18n.deleteButtonTextProtectedTag : this.$options.i18n.deleteButtonText;
        },
        tagNameConfirmed () {
            return this.enteredTagName === this.tagName;
        },
        deleteButtonDisabled () {
            return this.isProtected && !this.tagNameConfirmed;
        }
    },
    mounted () {
        eventHub.$on('openModal', this.openModal);
        for (const btn of document.querySelectorAll('.js-delete-tag-button')){
            btn.addEventListener('click', this.deleteTagBtnListener.bind(this, btn));
        }
    },
    destroyed () {
        eventHub.$off('openModal', this.openModal);
        for (const btn of document.querySelectorAll('.js-delete-tag-button')){
            btn.removeEventListener('click', this.deleteTagBtnListener.bind(this, btn));
        }
    },
    methods: {
        deleteTagBtnListener (btn) {
            return this.openModal({
                ...btn.dataset,
                isProtected: parseBoolean(btn.dataset.isProtected)
            });
        },
        openModal ({ isProtected, tagName, path }) {
            this.enteredTagName = '';
            this.isProtected = isProtected;
            this.tagName = tagName;
            this.path = path;
            this.$refs.modal.show();
        },
        submitForm () {
            if (!this.deleteButtonDisabled) {
                this.$refs.form.submit();
            }
        },
        closeModal () {
            this.$refs.modal.hide();
        }
    },
    i18n: I18N_DELETE_TAG_MODAL
};
